export const config = {
  // GitHub username for the `projects` command. Empty → the command errors.
  githubUser: 'jazho76',

  // PostHog project key. Client-visible (inlined in built JS), not a secret.
  // Replace with your own, or leave empty to disable analytics.
  posthogKey: 'phc_u4oEDWSpv3iDhCeVvJbVjuzpSJbpQk6fy9BrJQZKpNqH',

  // Shell hostname override. undefined → derive from window.location.hostname.
  hostname: undefined as string | undefined,

  // Browser tab title. undefined → use the resolved hostname.
  title: 'Joaquin Pinillos | Shell Portfolio' as string | undefined,
} as const;
